import type { OnboardingResumeSource } from "@redotech/redo-onboarding-api/resume-source";
import type { Auth } from "./auth";

interface AuthHandoffTrackingState {
  current: boolean;
}

export function trackAuthHandoffOnce(
  auth: Pick<Auth, "handoffSource" | "resumeSource" | "teamId"> | undefined,
  trackingState: AuthHandoffTrackingState,
  logEvent: (
    eventName: string,
    properties: {
      resume_source?: OnboardingResumeSource;
      source: string;
      team_id: string;
    },
  ) => void,
): void {
  if (!auth?.handoffSource || trackingState.current) {
    return;
  }
  trackingState.current = true;
  logEvent("onboarding_auth_handoff", {
    ...(auth.resumeSource ? { resume_source: auth.resumeSource } : {}),
    source: auth.handoffSource,
    team_id: auth.teamId,
  });
}
